module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/1_3d658559755431e252fe6049d19f22f0.png";